import { render } from "./Scope-Of-Work.vue?vue&type=template&id=6af6d952"
import script from "./Scope-Of-Work.vue?vue&type=script&lang=js"
export * from "./Scope-Of-Work.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__